// ---------------------------------------------------------------------------
// Series
// ---------------------------------------------------------------------------

export interface BarChartSeriesEmphasis {
  /** Indices of bars within this series to visually emphasise */
  readonly indices: number[];
  /** Override color for emphasised bars (defaults to a darker shade of the series color) */
  readonly color?: string;
  /** Label shown above emphasised bars (e.g. "Mode") */
  readonly label?: string;
}

export interface BarChartSeries {
  /** Display name shown in the legend and tooltip */
  readonly name: string;
  /** One numeric value per category */
  readonly values: number[];
  /** Bar color (hex). Falls back to a built-in palette when omitted */
  readonly color?: string;
  /** Optional emphasis for specific bars */
  readonly emphasis?: BarChartSeriesEmphasis;
}

// ---------------------------------------------------------------------------
// Params
// ---------------------------------------------------------------------------

export interface BarChartParams {
  /** Shared x-axis labels */
  readonly categories: string[];
  /** One or more data series */
  readonly series: BarChartSeries[];
  /** X-axis label */
  readonly xAxisLabel?: string;
  /** Y-axis label (default: "Frequency") */
  readonly yAxisLabel?: string;
}

// ---------------------------------------------------------------------------
// Defaults
// ---------------------------------------------------------------------------

/** Built-in palette used when series don't specify a color */
export const BAR_CHART_PALETTE = ['#7ccafd', '#f9a8d4', '#a5b4fc', '#fcd34d', '#6ee7b7'] as const;
